// extracted by mini-css-extract-plugin
export var box = "_99-1";
export var checked = "_99-2";
export var descriptionSpacer = "_99-9";
export var disabled = "_99-3";
export var icon = "_99-6";
export var input = "_99-0";
export var labelSpacer = "_99-8";
export var medium = "_99-5";
export var small = "_99-4";
export var text = "_99-7";